<template>
  <div id="app">
    <transition :name="transitionName">
      <keep-alive include="home">
          <router-view class="child-view"> </router-view>
      </keep-alive>
    </transition>
  </div>
</template>
<script>
export default {
  data () {
    return{
      transitionName: 'slide-left'
    }
  },
  watch: {
    $route(to, from) {
      // console.log(to.meta.index,from.meta.index)
      if (to.meta.index > from.meta.index) {
        this.transitionName = "slide-left";
      } else {
        this.transitionName = "slide-right";
      }
    }
  },
  mounted(){

  },  
  methods:{

  }
}
</script>
<style scoped>
#app {
  width: 100%;
  height: 100%;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background-color: #f9f9f9;
}
.child-view {
    position: absolute;
    width:100%;
    transition: all .4s ;
}
.slide-left-enter, .slide-right-leave-active {
    opacity: 0;
    -webkit-transform: translate(100%, 0);
    transform: translate(100%, 0);
}
.slide-left-leave-active, .slide-right-enter {
    opacity: 0;
    -webkit-transform: translate(-100%, 0);
    transform: translate(-100%, 0);
}
.mask-box{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0,0,0,.5);
}
.update-version{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  width: 60%;
  background-color: #fff;
  border-radius: 5px;
}
.update-content{
  padding: 15px;
  font-size: 12px;
}
.footer-btn{
  padding: 10px 15px;
  border-top: 1px solid #dddddd;
  text-align: center;
}
.update-btn{
  padding: 5px 7px;
  background-color: rgb(243, 176, 71);
  color: #fff;
  border-radius: 5px;
  border: none;
  outline: none;
  font-size: 12px;
}
</style>
